export const mail = {
    "mailLog": {
        "mailLog01": "已寄出",
        "mailLog02": "未寄出",
        "mailLog03": "查詢日期",
        "mailLog04": "寄件者",
        "mailLog05": "收件者",
        "mailLog06": "副本",
        "mailLog07": "密件",
        "mailLog08": "寄送狀態",
        "mailLog09": "公告日期"
    },
    "mailQueue": {
        "mailQueue01": "已寄出",
        "mailQueue02": "未寄出",
        "mailQueue03": "寄件者",
        "mailQueue04": "郵件主旨",
        "mailQueue05": "建立日期",
        "mailQueue06": "寄出狀態",
        "mailQueue07": "寄出時間",
        "mailQueue08": "選擇範本...",
        "mailQueue09": "收件者",
        "mailQueue10": "郵件主旨",
        "mailQueue11": "郵件內容",
        "mailQueue12": "寄件者抬頭",
        "mailQueue13": "寄件者地址",
        "mailQueue14": "收件者抬頭",
        "mailQueue15": "收件者地址",
        "mailQueue16": "郵件排程-新增",
        "mailQueue17": "郵件排程-修改",
        "mailQueue18": "郵件排程-檢視"
    },
    "mailRole": {
        "mailRole01": "角色代碼",
        "mailRole02": "角色名稱",
        "mailRole03": "帳戶數",
        "mailRole04": "使用者",
        "mailRole05": "郵件角色-新增",
        "mailRole06": "郵件角色-修改"
    },
    "mailSet": {
        "mailSet01": "範本名稱",
        "mailSet02": "範本主旨",
        "mailSet03": "郵件範本",
        "mailSet04": "寄、收件者",
        "mailSet05": "範本編號",
        "mailSet06": "郵件主旨",
        "mailSet07": "電子郵件",
        "mailSet08": "郵件角色",
        "mailSet09": "寄件類型",
        "mailSet10": "寄件對象",
        "mailSet11": "郵件地址",
        "mailSet12": "郵件抬頭",
        "mailSet13": "郵件內容",
        "mailSet14": "郵件範本-新增",
        "mailSet15": "郵件範本-修改"
    }
}